import { render } from "./LogoPresentation.vue?vue&type=template&id=09203638&scoped=true"
import script from "./LogoPresentation.vue?vue&type=script&lang=js"
export * from "./LogoPresentation.vue?vue&type=script&lang=js"

import "./LogoPresentation.vue?vue&type=style&index=0&id=09203638&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09203638"]])

export default __exports__